import * as managementActions from 'client/actions/actionsManagement'
import { AsyncCodeEditor } from 'client/components/core/CodeEditor'
import useManagement, {
  selectors as managementSelectors,
} from 'client/hooks/useManagement'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

export const useAceEditor = () => {
  const [AceEditor, setAceEditor] = useState<AsyncCodeEditor | null>(null)
  const isCodeDialogPortalAllowed = useManagement(
    managementSelectors.isCodeDialogPortalAllowed,
  ) as boolean

  const dispatch = useDispatch()

  const loadCodeEditor = async () => {
    const { default: aceEditor } = await import(
      /* webpackChunkName: "code-editor" */ 'client/components/core/CodeEditor'
    )
    setAceEditor(() => aceEditor)
  }

  const onOpenCodeEditor = async () => {
    if (!AceEditor) {
      await loadCodeEditor()
    }
    dispatch(managementActions.showCodeDialog())
  }

  return {
    AceEditor: isCodeDialogPortalAllowed && AceEditor,
    onOpenCodeEditor,
  }
}
